// sm-announcement-live: pause/resume the CSS marquee (button + hover, matching the
// live bar), locale <details> outside-click/Esc close, and remembers a manual
// language choice so sm-geo-redirect never overrides it.
document.addEventListener('click', (e) => {
  const pause = e.target.closest('.sm-announcement-live__pause');
  if (pause) {
    const bar = pause.closest('.sm-announcement-live__bar');
    const paused = bar.classList.toggle('is-paused');
    pause.setAttribute('aria-pressed', String(paused));
    return;
  }
  document.querySelectorAll('[data-live-locale].is-open').forEach((el) => {
    if (!el.contains(e.target)) setOpen(el, false);
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('[data-live-locale].is-open').forEach((el) => {
    setOpen(el, false);
    el.querySelector('[data-live-locale-trigger]')?.focus();
  });
});

function setOpen(wrap, open) {
  wrap.classList.toggle('is-open', open);
  wrap.querySelector('[data-live-locale-trigger]')?.setAttribute('aria-expanded', String(open));
}

// Country picker: click toggles, hover opens with a short grace on leave (as on the live site).
document.querySelectorAll('[data-live-locale]').forEach((wrap) => {
  const trigger = wrap.querySelector('[data-live-locale-trigger]');
  let timer;
  const canHover = window.matchMedia('(hover: hover)').matches;
  let openedAt = 0;
  trigger?.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = wrap.classList.contains('is-open');
    // hover already opened it a moment ago: the click should not close it again
    if (isOpen && canHover && Date.now() - openedAt < 600) return;
    setOpen(wrap, !isOpen);
    if (!isOpen) openedAt = Date.now();
  });
  if (canHover) {
    wrap.addEventListener('mouseenter', () => { clearTimeout(timer); if (!wrap.classList.contains('is-open')) openedAt = Date.now(); setOpen(wrap, true); });
    wrap.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(() => setOpen(wrap, false), 160); });
  }
  // a manual language choice is remembered so the country redirect never overrides it
  wrap.querySelectorAll('[data-live-lang]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.cookie = `sm-lang=${btn.value};path=/;max-age=31536000;samesite=lax`;
    });
  });
});
